import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AbstractApiGuardService } from '../abstract.api-guard.service';
import Asset from '../../../shared/models/asset.model';

@Injectable({
    providedIn: 'root',
})
export class AssetsService extends AbstractApiGuardService {
    private readonly apiUrl = `${environment.apiVersionString}/assets`;

    // Create an asset
    createAsset(asset: Asset, applicant_id: string): Observable<Asset> {
        return this.post(`${this.apiUrl}/${applicant_id}`, asset);
    }

    // Read all assets
    getAssets(): Observable<Asset[]> {
        return this.get(this.apiUrl);
    }

    // Read a single asset by ID
    getAssetById(id: string): Observable<Asset> {
        return this.get(`${this.apiUrl}/${id}`);
    }

    // Update an asset
    updateAsset(id: string, asset: Asset): Observable<Asset> {
        return this.put(`${this.apiUrl}/${id}`, asset);
    }

    // Delete an asset
    deleteAsset(id: string): Observable<void> {
        return this.delete(`${this.apiUrl}/${id}`);
    }

    // Read a single asset by ID
    getAssetsByApplicantId(id: string): Observable<Asset[]> {
        return this.get(`${this.apiUrl}/applicant_uuid/${id}`);
    }
}
